import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7675ebf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "observation-history__header" }

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { ObservationHistoryType } from '@/shared/types'
import ObservationHistoryChart from '@/entities/EObservationHistory/components/ObservationHistoryChart.vue'

interface Props {
  observationHistory: ObservationHistoryType[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    observationHistory: null
  },
  setup(__props: any) {

const props = __props as {
  observationHistory: ObservationHistoryType[]
}



const route = useRoute()

const isAllHistoryVisible = ref(false)

const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const visibleHistory = computed((): ObservationHistoryType[] => {
  if (isAllHistoryVisible.value) {
    return props.observationHistory
  }

  return props.observationHistory.slice(0, 3)
})

const handleHistoryCollapse = () => {
  isAllHistoryVisible.value = !isAllHistoryVisible.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["observation-history", {
      'observation-history--preview': _unref(isPreviewMode),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(["observation-history__title", {
          'observation-history__title--preview': _unref(isPreviewMode),
        }])
      }, " История наблюдений ", 2),
      (!isAllHistoryVisible.value)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "observation-history__show",
            onClick: handleHistoryCollapse
          }, " Вся история "))
        : (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "observation-history__show",
            onClick: handleHistoryCollapse
          }, " Скрыть историю "))
    ]),
    _createVNode(ObservationHistoryChart, {
      class: "observation-history__chart",
      history: _unref(visibleHistory)
    }, null, 8, ["history"])
  ], 2))
}
}

})